var module = angular.module('octopusApp.master');

module.directive('browserWarning', function () {

    return {
        restrict: 'E',
        replace: true,
        transclude: false,
        templateUrl: 'areas/master/views/browser-warning.html',
        link: function (scope, element) {
        },
        controller: function ($scope, $document, $localStorage) {

            $scope.dismiss = function(){
                $localStorage.hideIEVersionNotSupportedWarning = true;
            };

            $scope.hideWarning = $localStorage.hideIEVersionNotSupportedWarning;
            if ($scope.hideWarning) return;

            // Based on http://stackoverflow.com/questions/10964966/detect-ie-version-prior-to-v9-in-javascript
            var ieVersion = $document[0].documentMode;
            if (ieVersion && ieVersion <= 10) {
                $scope.browserName = "Internet Explorer " + ieVersion;
            } else {
                $scope.hideWarning = true;
            }
        }
    };
});







//////////////////
// WEBPACK FOOTER
// ./app/areas/master/directives/browser_warning.js
// module id = 5457445962062294
// module chunks = 1